<template>
<div class="">
    <ListContent
      :algolia="null"
      :wrld="null"
    >
      <template v-slot:listActionPanel>
        <WrldListActionPanel :actions="panelActions" :isCheckable="false" :wrld="null" />
      </template>
      <template v-slot:list>
        <div
          v-if="!isVehicleClassListLoading && items.length > 0"
        >
          <ListItemCardBig
            v-for="item in items"
            :key="item.id"
            color="#ef476f"
            :resource="item"
            :actions="cardActions"
            :isCheckable="false"
            :isSecondLevel="true"
          >
            <VehicleClassOverviewCard :vehicleClass="item" />
          </ListItemCardBig>
        </div>
        <div v-else-if="isVehicleClassListLoading" class="drop--sortable--tree__container">
          <div v-for="(key, index) in new Array(10)" :key="index" class="drop--sortable--tree__card drop--sortable--tree--card__topLevel placeholderLoader background--transparent">
          </div>
        </div>
        <div v-else-if="items.length < 1" class="drop--sortable--tree__container">
          {{ $t('organizations.empty_fleet') }}
        </div>
      </template>
    </ListContent>
    <AddVehicleClass :openMenu="isOpenAddVehicleClass" @close="isOpenAddVehicleClass = false" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { vehicleService } from '@/_services'

import ListItemCardBig from '@/components/wrld/generic/ListItemCardBig'
import ListContent from '@/components/wrld/generic/ListContent'
import WrldListActionPanel from '@/components/wrld/generic/WrldListActionPanel'
import VehicleClassOverviewCard from '@/components/organizations/fleet/VehicleClassOverviewCard'
import AddVehicleClass from '@/components/organizations/fleet/AddVehicleClass'

export default {
  name: 'VehicleClassOverviewContent',
  components: {
    ListItemCardBig,
    ListContent,
    WrldListActionPanel,
    VehicleClassOverviewCard,
    AddVehicleClass
  },
  props: {},
  data () {
    return { // CHANGE ALGOLIA INDEX
      isOpenAddVehicleClass: false,
      isVehicleClassListLoading: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.handleFetchVehicleClassesList()
    })
  },
  computed: {
    ...mapGetters([
      'getCheckedOnPageCount',
      'getSecondResourceOverviewList'
    ]),
    checkedOnPageCount () {
      return this.getCheckedOnPageCount(this.actualPage)
    },
    cardActions () {
      let icons = []
      if (this.checkedOnPageCount > 0) {
        // icons.push(
        // {
        //   icon: 'archive',
        //   tooltip: 'Archive',
        //   callback: this.archiveDrops,
        //   loading: false
        // },
        // )
      }
      return icons
    },
    panelActions () {
      let icons = []
      icons.push(
        {
          icon: 'fas fa-plus',
          tooltip: this.$t('fleet.add_contract_vehicles'),
          callback: this.handleVehicleClass,
          loading: false,
          iconSize: '18'
        }
      )
      if (this.checkedOnPageCount > 0) {
      }
      return icons
    },
    items () {
      return this.getSecondResourceOverviewList
    }
  },
  methods: {
    ...mapActions({
      setSecondResourceOverviewList: 'setSecondResourceOverviewList'
    }),
    handleVehicleClass () {
      this.isOpenAddVehicleClass = true
    },
    handleFetchVehicleClassesList () {
      this.isVehicleClassListLoading = true
      vehicleService.listVehicleClasses({ organizationID: this.$route.params.organizationID }).then((items) => {
        this.setSecondResourceOverviewList({ items })
      }).catch((error) => {
        console.log(error)
        this.setSecondResourceOverviewList({ items: [] })
      }).finally(() => {
        this.isVehicleClassListLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
